/** A naive implementation of getting a week number from a given date. */
function getWeek(d: Date): number {
  const onejan = new Date(d.getFullYear(), 0, 1);
  const dayOfYear = (d.getTime() - onejan.getTime() + 86400000) / 86400000 + 1
  return Math.ceil(dayOfYear / 7)
}

/** Returns the week number of the given date or string. */
export function dateToWeekNumber(date: Date | string): number {
  if (typeof date === "string") {
    date = new Date(date);
  }

  const brochureWeekNumber = getWeek(date)
  return brochureWeekNumber;
}


/** Returns the week number of $TODAY. */
export function currentDateWeekNumber(): number {
  const currentWeekNumber = getWeek(new Date())

  return currentWeekNumber;
}
